export function invitationReturnPath(
  value: string | undefined,
  origin: string
) {
  try {
    const url = new URL(value || '/', origin);
    if (
      url.origin !== new URL(origin).origin ||
      url.username ||
      url.password ||
      url.pathname.startsWith('//')
    )
      return '/';
    return url.pathname + url.search + url.hash;
  } catch {
    return '/';
  }
}
